module.exports = __webpack_public_path__ + "static/img/hero4.2055eeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hero4.png
// module id = YqLQ
// module chunks = 1